<template>
  <button class="btn btn-sm fixed bottom-10 right-3 z-40 flex items-center justify-center gap-4 whitespace-nowrap rounded-3xl bg-violet-light px-4 text-violet shadow-2xl">
    <span class="sr-only">Instellingen</span>
    <IconsSettings class="scale-125" />
  </button>
</template>
